// components/common/CommonDialog.js

import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Box,
    makeStyles,
    IconButton,
    Grid,
} from "@material-ui/core";
import MROButton from 'components/buttons';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import EditIcon from "@material-ui/icons/Edit";
import { getColors } from 'lib/utils/common_utils';

const useStyles = makeStyles((theme) => ({
    actionButtons: {
        paddingTop: "37px",
        paddingBottom: "10px",
        textAlign: "right",
        "& button:not(:last-child)": {
            marginRight: "20px",
        },
    },
    modal: {
        "& .MuiDialog-paperWidthMd": {
            maxWidth: "750px",
            padding: '15px'
        },
    }, modal1: {
        "& .MuiDialog-paperWidthMd": {
            maxWidth: "500px",
            padding: '15px'
        },
    },
    title: {
        "& h2": {
            // color: theme.palette.primary.main,
        },
        "& span": {
            color: theme.palette.primary.main,
            fontSize: 22,
            textAlign: 'center'
        },
    },
}));

export default function CommonDialog({
    open = true,
    onClose,
    onSubmit,
    title,
    children,
    loading,
    submitLabel = "Submit",
    width,
    edit = false,
    subText,
    showIcon,
    icon,
    setEdit,
    showEdit = false,
    paddingleft,
    editAction,
    fontSize,
    ...props

}) {
    const classes = useStyles();

    return (
        <Dialog
            maxWidth={"md"}
            fullWidth={true}
            open={open}
            className={props?.classes ? props?.classes : width ? classes.modal1 : classes.modal}
            onClose={onClose}
        >
            <DialogTitle className={classes.title}>
                <Grid style={{ display: "flex", justifyContent: "space-between" }}>
                    <Box display="flex" alignItems="center">
                        <Typography
                            style={{ fontSize: fontSize ?? "17px", paddingLeft: paddingleft && paddingleft }}
                            variant="h5"
                            color="primary"
                        >
                            {title} &nbsp;&nbsp;
                            {showEdit && (
                                <IconButton style={{
                                    marginTop: "-9px",
                                    marginLeft: "28px"
                                }}>
                                    <EditIcon
                                        fontSize="medium"
                                        htmlColor={"#00000080"}
                                        onClick={() => setEdit(true)}
                                    />
                                </IconButton>
                            )}
                        </Typography>
                    </Box>
                    {showIcon && <IconButton>
                        <Box display="flex" justifyContent="center">
                            {" "}
                            <img src={icon} alt="Icon" />{" "}
                        </Box>
                    </IconButton>}
                </Grid>
                {subText && <Typography color='' style={{ fontSize: "14px" }}>
                    {subText}
                </Typography>}



            </DialogTitle>
            <DialogContent>
                <form onSubmit={onSubmit}>
                    {children}
                    {edit && <Box display="flex" width="100%" justifyContent={editAction ? editAction : "center"} className={classes.actionButtons}>
                        <MROButton type="button" variant="contained" onClick={onClose} style={{ marginRight: 20 }}>
                            Cancel
                        </MROButton>
                        <MROButton type="submit" color="primary" variant="contained" loading={loading}>
                            {submitLabel}
                        </MROButton>
                    </Box>}
                </form>
            </DialogContent>
        </Dialog >
    );
}
